import { CheckboxButtonGroupValue } from "../../../models/Button"
import { CardFlag } from "../../../models/Card"
import CheckboxButtonGroup from "../../Control/Button/CheckboxButtonGroup"
import { EXBurstIcon } from "../../Icons/EXBurstIcon"
import { LBIcon } from "../../Icons/LBIcon"
import { ColumnLabel } from "../../Layout/ColumnLabel"

export type FlagSelectorProps = {
    values: CheckboxButtonGroupValue<CardFlag>[],
    update: (values: CheckboxButtonGroupValue<CardFlag>[]) => void
}

export function FlagSelector(props: FlagSelectorProps) {
    return (
        <ColumnLabel label="Flag">
            <CheckboxButtonGroup
                classNames={{
                    container: "!grid-cols-4",
                    button: "!min-h-[34px]"
                }}
                values={props.values}
                contentGenerator={(label, flag) => {
                    switch (flag) {
                        case "exburst":
                            return <EXBurstIcon classNames={{ svg: "w-5 h-5" }} />
                        case "generic":
                            return <span className={`ff-icon multicard`}></span>
                        case "limitbreak":
                            return <LBIcon classNames={{ svg: "h-5 w-5" }} />
                        case "special":
                            return <span className={`ff-icon special`}></span>
                        default:
                            return <>{label}</>
                    }
                }}
                onClick={(clickedValue, allValues) => props.update(allValues)} />
        </ColumnLabel>
    )
}